import { createFileRoute } from '@tanstack/react-router';
import { KnowledgeGapsPage } from '@/pages/knowledge-gaps-page';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/knowledge-gaps/'
)({
  component: KnowledgeGapsPage,
});